import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import ContactMe from "./components/pages/ContactMe";
import Home from "./components/pages/Home";
import { ToastContainer } from "react-toastify";
import ProjectDetail from "./components/pages/ProjectDetail";
import ParticlesBackground from "./components/ParticlesBackground";

function App() {
	return (
		<BrowserRouter>
			<div className="App bg-dark">
				<Navbar />
				<ToastContainer
					toastClassName="relative bg-gray-700 text-white flex p-1 min-h-10 rounded-md justify-between overflow-hidden cursor-pointer"
					position="top-right"
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>

				<ParticlesBackground />
				<main>
					<Routes>
						<Route path="" element={<Home />} />
						<Route path="contact-me" element={<ContactMe />} />
						<Route
							path="project/:projectId/:projectTitle"
							element={<ProjectDetail />}
						/>
					</Routes>
				</main>
				<Footer />
			</div>
		</BrowserRouter>
	);
}

export default App;
